import { GlobalAxios } from "../axios/axios-config";
import {
  IEditEsignEmailSendRule,
  IGetEsignEmailSendRule,
  INewEsignEmailSendRule,
} from "../models/esign-email-send-rule";

const ESIGN_EMAIL_SEND_RULE_ROUTE =
  process.env.REACT_APP_4UESIGN + "/api/v1/EsignEmailSendRule/";

export const getEsignEmailSendRuleById = (id: string) => {
  return GlobalAxios.get<IGetEsignEmailSendRule>(
    ESIGN_EMAIL_SEND_RULE_ROUTE + id,
  );
};

export const createEsignEmailSendRule = (item: INewEsignEmailSendRule) => {
  return GlobalAxios.post(ESIGN_EMAIL_SEND_RULE_ROUTE, item);
};

export const updateEsignEmailSendRuleById = ({
  item,
  id,
}: {
  item: IEditEsignEmailSendRule;
  id: string;
}) => {
  return GlobalAxios.put(ESIGN_EMAIL_SEND_RULE_ROUTE + id, item);
};
